module.exports = __webpack_public_path__ + "static/media/sidebar-bg.3e27ab41.jpg";